'use strict';
//polyfill for Object.assign

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function assignObject(target, varArgs) {
  // .length of function is 2
  'use strict';

  if (target === null) {
    // TypeError if undefined or null
    throw new TypeError('Cannot convert undefined or null to object');
  }

  var to = Object(target);

  for (var index = 1; index < arguments.length; index++) {
    var nextSource = arguments[index];

    if (nextSource !== null) {
      // Skip over if undefined or null
      for (var nextKey in nextSource) {
        // Avoid bugs when hasOwnProperty is shadowed
        if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
          to[nextKey] = nextSource[nextKey];
        }
      }
    }
  }
  return to;
}

// polyfill for Array.fill
function arrayFill(value) {

  // Steps 1-2.
  if (this === null) {
    throw new TypeError('this is null or not defined');
  }

  var O = Object(this);

  // Steps 3-5.
  var len = O.length >>> 0;

  // Steps 6-7.
  var start = arguments[1];
  var relativeStart = start >> 0;

  // Step 8.
  var k = relativeStart < 0 ? Math.max(len + relativeStart, 0) : Math.min(relativeStart, len);

  // Steps 9-10.
  var end = arguments[2];
  var relativeEnd = end === undefined ? len : end >> 0;

  // Step 11.
  var final = relativeEnd < 0 ? Math.max(len + relativeEnd, 0) : Math.min(relativeEnd, len);

  // Step 12.
  while (k < final) {
    O[k] = value;
    k++;
  }

  // Step 13.
  return O;
}

function fixDataFormat(data) {
  if (!Array.isArray(data) || !data.length) return [];else if (_typeof(data[0]) === 'object' && !Array.isArray(data[0])) return data;else {
    return data.reduce(function (dataCol, row, i, arr) {
      if (i !== 0) {
        if (Array.isArray(row)) {
          dataCol.push(row.reduce(function (acc, curr, index) {
            acc[arr[0][index]] = curr;
            return acc;
          }, {}));
        } else {
          dataCol.push(_defineProperty({}, arr[0], row));
        }
      }
      return dataCol;
    }, []);
  }
}

function groupByCategory(data, groupBy) {
  return data.reduce(function (acc, curr) {
    var category = curr[groupBy];
    if (!acc[category]) acc[category] = [];
    acc[category].push(curr);
    return acc;
  }, {});
}

function groupByCategories(data) {
  var groups = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var acc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

  if (!data.length) return [];

  groups = groups.filter(function (ele) {
    return ele in data[0];
  });

  if (!groups.length) return data;

  var groupCopy = assignObject([], groups);
  var groupedData = groupByCategory(data, groupCopy.shift());
  var groupedDataKeys = Object.keys(groupedData);
  var children = groupedDataKeys.map(function (el) {
    return groupedData[el];
  });
  for (var i = 0; i < children.length; i++) {
    acc[groupedDataKeys[i]] = groupCopy.length ? {} : [];
    acc[groupedDataKeys[i]] = groupByCategories(children[i], groupCopy, acc[groupedDataKeys[i]]);
  }

  return acc;
}

function createColumnHeaders(data) {
  var cols = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var firstColumn = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

  if (!cols.length) return { columnHeaders: [firstColumn], mapToHeader: 1 };

  var groupedData = groupByCategories(data, cols);
  var columnHeaders = [];
  var mapToHeader = assignObject({}, groupedData);
  var mapPos = 1;

  (function columnHeaderRecursion(data) {
    var pos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var headerMap = arguments[2];

    if ((typeof data === 'undefined' ? 'undefined' : _typeof(data)) !== 'object' || Array.isArray(data)) return 1;else {
      var currKeys = Object.keys(data);
      var reqLength = 0;
      for (var i = 0; i < currKeys.length; i++) {
        var currLength = columnHeaderRecursion(data[currKeys[i]], pos + 1, headerMap[currKeys[i]]);
        if (Array.isArray(data[currKeys[i]])) {
          headerMap[currKeys[i]] = mapPos;
          mapPos += 1;
        }
        reqLength += currLength;
        columnHeaders[pos] = !columnHeaders[pos] ? [firstColumn].concat(arrayFill.call(Array(currLength), currKeys[i])) : columnHeaders[pos].concat(arrayFill.call(Array(currLength), currKeys[i]));
      }
      return reqLength;
    }
  })(groupedData, 0, mapToHeader);

  return {
    columnHeaders: columnHeaders,
    mapToHeader: mapToHeader
  };
}

//accumulator has two different signatures
//1. it takes an array of objects, an accumulation category as a string (like age), and supported accumulation type as a string (like count)
//2. it takes an array of objects, a callback function (which operates the same as reduce), and an initial value
function accumulator(arr, accCat, accType, accValue) {
  if (!accCat && typeof accType !== 'function') accType = 'count';else if (typeof accCat === 'function') {
    accValue = accType || 0;
    accType = accCat;
  }

  return arr.reduce(function (acc, curr, index, array) {
    if (typeof accType === 'function') {
      return accType(acc, typeof accCat === 'string' ? curr[accCat] : curr, index, array);
    }
    switch (accType) {
      case 'sum':
        {
          acc += Number(curr[accCat]);
          return acc;
        }

      case 'count':
        {
          acc += 1;
          return acc;
        }

      default:
        {
          acc += 1;
          return acc;
        }
    }
  }, accValue || 0);
}

function tableCreator(data) {
  var rows = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var cols = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];
  var accCatOrCB = arguments[3];
  var accTypeOrInitVal = arguments[4];
  var rowHeader = arguments[5];

  data = fixDataFormat(data);
  if (typeof rowHeader === 'undefined') rowHeader = typeof accCatOrCB !== 'function' ? accTypeOrInitVal + ' ' + accCatOrCB : 'Custom Agg';

  var columnData = createColumnHeaders(data, cols, rowHeader);
  var columnHeaders = Array.isArray(columnData.columnHeaders[0]) ? columnData.columnHeaders : [columnData.columnHeaders.concat(rowHeader)];
  var mapToHeader = columnData.mapToHeader;
  var headerLength = columnHeaders[0].length;

  var dataRows = [];
  var rawData = [];
  var prevKey = '';

  function rowRecurse(rowGroups) {
    var _loop = function _loop(key) {
      if (Array.isArray(rowGroups[key])) {
        recursedData = groupByCategories(rowGroups[key], cols);


        (function recurseThroughMap(dataPos, map) {
          if (Array.isArray(dataPos)) {
            if (key === prevKey) {
              var datum = dataRows[dataRows.length - 1];
              datum[map] = accumulator(dataPos, accCatOrCB, accTypeOrInitVal);
              dataRows[dataRows.length - 1] = datum;

              var rawDataDatum = rawData[rawData.length - 1];
              rawDataDatum[map] = dataPos;
              rawData[rawData.length - 1] = rawDataDatum;
            } else {
              prevKey = key;
              var _datum = [key].concat(arrayFill.call(Array(map - 1), ''), accumulator(dataPos, accCatOrCB, accTypeOrInitVal), arrayFill.call(Array(headerLength - (map + 1)), ''));
              var _rawDataDatum = [key].concat(arrayFill.call(Array(map - 1), ''), [dataPos], arrayFill.call(Array(headerLength - (map + 1)), ''));
              rawData.push(_rawDataDatum);
              dataRows.push(_datum);
            }
          } else {
            for (var innerKey in dataPos) {
              recurseThroughMap(dataPos[innerKey], map[innerKey]);
            }
          }
        })(recursedData, mapToHeader || 1);
      } else {
        dataRows.push([key].concat(arrayFill.call(Array(headerLength - 1), '')));
        rowRecurse(rowGroups[key], key);
      }
    };

    for (var key in rowGroups) {
      var recursedData;

      _loop(key);
    }
  }

  if (rows.length || cols.length) rowRecurse(groupByCategories(data, rows.length ? rows : cols));else {
    dataRows.push([rowHeader, accumulator(data, accCatOrCB, accTypeOrInitVal)]);
    rawData = data;
  }

  return {
    table: columnHeaders.concat(dataRows),
    rawData: rawData
  };
}

module.exports = {
  tableCreator: tableCreator,
  fixDataFormat: fixDataFormat,
  groupByCategory: groupByCategory,
  groupByCategories: groupByCategories,
  createColumnHeaders: createColumnHeaders,
  accumulator: accumulator
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/quick-pivot/transpiled.js
 ** module id = 934
 ** module chunks = 0
 **/